import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { sparePartsList } from "constants/spareParts";
import { requestSparePartsList } from "constants/requestSpareParts";

//Add Spare Part
export const addSparePart = async (bodyData) => {
  try {
    const res = await api.add_spare_part(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

// Get Spare Parts list
export const getSparePartList = async (
  dispatch,
  pageNum,
  filters,
  searchString,
) => {
  try {
    const res = await api.get_spare_part_list(pageNum, filters, searchString);
    dispatch({ type: sparePartsList, payload: res.data });
  } catch (error) {
    dispatch({ type: sparePartsList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

// Edit Spare Part
export const editSparePart = async (id, bodyData) => {
  try {
    const res = await api.edit_spare_part(id, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get spare part detail by id
export const getSparePartByID = async (id) => {
  try {
    const res = await api.get_spare_part_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Get Request Spare Parts List
export const getRequestSparePartsList = async (
  dispatch,
  pageNum,
  filters,
  searchString,
) => {
  try {
    const res = await api.get_Request_Spare_Parts_List(
      pageNum,
      filters,
      searchString,
    );
    dispatch({ type: requestSparePartsList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: requestSparePartsList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};


// export spare parts
export const exportSparePartsCSV = async ({ filters, searchString } = {}) => {
  try {
    const res = await api.export_spare_parts(filters, searchString);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};